'use client'

import React from 'react'

import { useActiveOrg } from '~/hooks/org'
import { useNavigation } from '~/hooks/useNavigation'
import { PrivacyModeExempt } from '~/hooks/usePrivacyMode'

export default function SettingsLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const { org: activeOrg, isLoading } = useActiveOrg()
  const navigate = useNavigation()

  if (isLoading) {
    return null
  }

  if (!activeOrg?.id) {
    navigate('/')
    return null
  }

  return <PrivacyModeExempt>{children}</PrivacyModeExempt>
}
